var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v("Custom Component")]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-6 col-md-4 col-lg-3" }, [
        _c(
          "button",
          { staticClass: "btn btn-info btn-sm", on: { click: _vm.normal } },
          [_vm._v("Normal")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "markdown-container" },
          [_c("NormalSnippet")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 col-md-8 col-lg-9" }, [
        _c(
          "button",
          { staticClass: "btn btn-info btn-sm", on: { click: _vm.form } },
          [_vm._v("Form")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6" }, [
            _c(
              "div",
              { staticClass: "markdown-container" },
              [
                _c("strong", [_vm._v("Main")]),
                _vm._v(" "),
                _c("FormMainSnippet")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6" }, [
            _c(
              "div",
              { staticClass: "markdown-container" },
              [
                _c("strong", [_vm._v("Form.vue")]),
                _vm._v(" "),
                _c("FormComponentSnippet")
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27af4442", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27af4442","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resource/Example/CustomeComponent/CustomeComponent.vue
// module id = null
// module chunks = 